<template>
  <b-container fluid>
    <b-row v-if="shipping.shipping_type_id">
      <b-col lg="8">
        <b-card class="shipping-info" :class="shipping.status.toLowerCase() + ' border-' + statusColorVariant">
          <h4>
            <span v-translate="{shippingId: shipping.id}">Shipment <strong>%{shippingId}</strong></span>
            <a href="#" @click.prevent="copyToClipboard(shipping.id)" class="text-secondary" :title="this.$gettext('Copy to Clipboard')">
              <font-awesome-icon :icon="['far', 'copy']" size="1x" />
            </a>
            <shippings-list-item-status :shipping="shipping" />
            <b-button variant="link" @click="getShipping" class="px-1" :title="this.$gettext('Reload')">
              <font-awesome-icon icon="sync-alt" size="lg" />
            </b-button>
          </h4>
          <b-button-group justify class="mb-3">
            <b-button size="sm" @click.prevent v-b-modal="'modalShippingMap' + shipping.id" :disabled="!shipping.address_from || !shipping.address_to" v-translate>
              View Shipment Map
            </b-button>
            <modal-shipping-map :shipping="shipping" update-every="30" without-button with-tracking />
          </b-button-group>

          <dl v-if="shipping.tour_id">
            <dt v-translate>In Tour</dt>
            <dd><router-link :to="{ name: 'ToursEdit', params: { id: shipping.tour_id } }" target="_blank">{{shipping.tour_id}}</router-link> <a href="#" @click.prevent="copyToClipboard(shipping.tour_id, 'Tour ID')" class="text-secondary" :title="this.$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a></dd>
          </dl>
          <hr>
          <b-row v-if="shipping.previous_shipping || shipping.following_shippings.length > 0">
            <b-col>
              <h4><translate>Roundtrip Shipping:</translate>
                <strong v-if="!shipping.previous_shipping">Forth</strong>
                <span v-else>
                  <router-link :to="{name: 'viewShipping', params: {'id': shipping.previous_shipping.id}}">Forth</router-link>
                  <small><small><a href="#" @click.prevent="copyToClipboard(shipping.previous_shipping.id)" class="text-secondary" :title="this.$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a></small></small>
                </span>
                <font-awesome-icon icon="exchange-alt" size="1x" />
                <strong v-if="!shipping.following_shippings || shipping.following_shippings.length === 0">Back</strong>
                <span v-else>
                  <router-link :to="{name: 'viewShipping', params: {'id': shipping.following_shippings[0].id}}">Back</router-link>
                  <small><small><a href="#" @click.prevent="copyToClipboard(shipping.following_shippings[0].id)" class="text-secondary" :title="this.$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a></small></small>
                </span>
              </h4>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>
                <strong v-translate>Created</strong><br>
                {{moment.utc(shipping.created_at).tz($tz).format('L LT')}}
              </p>
              <p>
                <strong v-translate>Type</strong><br>
                <span v-show="editing !== 'shipping_type_id'">
                  {{shippingTypesShared.find(x => x.value=== shipping.shipping_type_id) ? shippingTypesShared.find(x => x.value === shipping.shipping_type_id).text : ''}}
                </span>
                <span v-if="(shippingTypes.findIndex(x => x.text === 'pickup') !== -1 && shipping.shipping_type_id === shippingTypes.find(x => x.text === 'pickup').value) || (shippingTypes.findIndex(x => x.text === 'return') !== -1 && shipping.shipping_type_id === shippingTypes.find(x => x.text === 'return').value)">
                  <b-button size="sm" class="py-0 px-1" v-b-modal.modalPickedupShippings><font-awesome-icon :icon="['far', 'eye']" size="2x" style="font-size: 16px;vertical-align: middle" /></b-button>
                  <b-modal size="lg" id="modalPickedupShippings" ref="modalPickedupShippings" :hide-footer="true">
                    <div slot="modal-title" v-translate>Picked Up Shippings</div>
                    <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
                    <shipping-pickedup-shippings :shipping-id="shipping.id" />
                  </b-modal>
                </span>
              </p>
            </b-col>
            <b-col>
              <p>
                <strong v-translate>Last Modified</strong><br>
                {{moment.utc(shipping.updated_at).tz($tz).format('L LT')}}
              </p>
              <p>
                <strong v-translate>Size</strong><br>
                <span v-show="editing !== 'size_id'">
                  {{shippingSizes.find(x => x.id === shipping.size_id) ? shippingSizes.find(x => x.id === shipping.size_id).name : ''}}
                </span>
              </p>
            </b-col>
            <b-col>
              <p>
                <strong v-translate>Secret Code</strong><br>
                {{shipping.secret_code}}
              </p>
              <p v-if="shipping.external_code">
                <strong v-translate>External Code</strong><br>
                {{shipping.external_code | cleanentityprefix}}
              </p>
            </b-col>
            <b-col v-if="shipping.external_order_id">
              <p>
                <strong v-translate>External Order ID</strong><br>
                {{shipping.external_order_id | cleanentityprefix}}
              </p>
            </b-col>
          </b-row>
          <b-row v-if="shipping.courier_commission">
            <b-col cols="12">
              <hr>
            </b-col>
            <b-col>
              <p class="mb-0">
                <strong v-translate>Commission</strong><br>
                {{shipping.courier_commission | currency(shipping.to_country_iso_code)}}
              </p>
            </b-col>
          </b-row>
          <b-row v-if="shipping.estimated_pickup_date || shipping.pickup_note || shipping.estimated_delivery_date || shipping.delivery_note">
            <b-col cols="12">
              <hr>
            </b-col>
            <b-col v-if="shipping.estimated_pickup_date || shipping.pickup_note">
              <div v-if="shipping.estimated_pickup_date">
                <h5 v-translate>Est. Pickup Date</h5>
                <p>{{moment.utc(shipping.estimated_pickup_date).tz($tz).format('L LT')}}</p>
              </div>
              <div v-if="shipping.pickup_note">
                <h5 v-translate>On Pickup Note</h5>
                <p>{{shipping.pickup_note}}</p>
              </div>
            </b-col>
            <b-col v-if="shipping.estimated_delivery_date || shipping.delivery_note">
              <div v-if="shipping.estimated_delivery_date">
                <h5 v-translate>Est. Delivery Date</h5>
                <p>{{moment.utc(shipping.estimated_delivery_date).tz($tz).format('L LT')}}</p>
              </div>
              <div v-if="shipping.delivery_note">
                <h5 v-translate>On Delivery Note</h5>
                <p>{{shipping.delivery_note}}</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <hr>
              <h5>
                <translate>General instructions</translate>
                <b-button v-if="isEditable" size="sm" variant="link" style="padding:0 .5rem" @click.prevent="Object.assign(originalShipping, shipping); editing = 'instructions'" :disabled="editing !== null"><font-awesome-icon icon="edit" /></b-button>
              </h5>
              <p><span v-show="editing !== 'instructions'">
                {{shipping.instructions}}
              </span>
              <b-input-group size="sm" v-show="editing === 'instructions'">
                <b-input type="text" v-model="shipping.instructions" @input="updatePatch(patchField, 'instructions', $event)" />
                <b-input-group-append>
                  <b-button size="sm" variant="success" @click.prevent="patchShipping"><font-awesome-icon icon="check" size="sm" /></b-button>
                  <b-button size="sm" variant="danger" @click.prevent="Object.assign(shipping, originalShipping); patchField = {}; editing = null" style="font-size: 1.3rem; line-height: .9;">×</b-button>
                </b-input-group-append>
              </b-input-group></p>
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <b-col lg="6">
            <b-card class="shipping-checkpoint" :class="'border-' + statusColorVariantFrom">
              <h5><translate>Origin</translate></h5>
              <shipping-checkpoint checkpoint="from" :shipping="shipping" @updated="getShipping" :with-edit="!ecosystemConfig.disableEditOrigins" with-instructions with-extra-checkpoints />
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card class="shipping-checkpoint" :class="'border-' + statusColorVariantTo">
              <h5><translate>Destination</translate></h5>
              <shipping-checkpoint checkpoint="to" :shipping="shipping" @updated="getShipping" :with-edit="!ecosystemConfig.disableEditDestinations" with-instructions with-extra-checkpoints />
            </b-card>
          </b-col>
        </b-row>
        <b-card v-if="!isShared && ecosystemModules.items?.self">
          <h4 v-translate="{itemsLabel: ecosystemModules.items.label || $gettext('Items')}">Shipment %{itemsLabel}</h4>
          <edit-field-items :placeholder="$gettext('Reference, or External ID')"
            :shipping="shipping"
            :single-item="true"
            :value="shipping?.items || []"
            @updated="getShipping"
          />
        </b-card>
        <b-row>
          <b-col md="6" lg="12" xl="6">
            <shipping-attachments :shipping="shipping" allow-delete @updated="getShipping" />
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="4">
        <b-card v-show="isEditable">
          <h5 v-translate>Op Actions</h5>
          <b-form @submit.prevent v-if="isAssignable">
            <b-form-row v-if="statusesMap[shipping.status].length > 0">
              <div class="form-group col-12" v-if="!courier || !courier.id || (!courier && !shipping.courier_id) || shipping.courier_id === courier.id">
                <label for="search-courier" v-translate>Assign this Shipment</label>
                <user-autocomplete ref="courierAc" endpoint="companies/users" @selected="onSearchCourierSelected" :placeholder="this.$gettext('Courier name or email')" :restrictToRoles="['courier']" with-picture />
              </div>
              <div class="form-group col-12" v-if="courier && courier.id && shipping.courier_id !== courier.id">
                <span class="label" v-translate>Assign to Courier</span>
                <user-card :user="courier" :with-titles="false" :with-map="false" />
              </div>
              <div class="form-group col-12">
                <div class="input-group">
                  <b-btn size="sm" v-if="courier" @click="assignShipping(shipping.id)" :disabled="!courier.id || shipping.courier_id === courier.id" v-translate>Assign!</b-btn>
                  <b-btn variant="warning" size="sm" v-if="allowResetCourier && courier && courier.id && shipping.courier_id !== courier.id" @click="courier = null" :disabled="!courier.id" class="ml-1" v-translate>Search again</b-btn>
                </div>
              </div>
            </b-form-row>
          </b-form>
          <shipping-status-update :shipping="shipping" @updated="getShipping" />
        </b-card>

        <b-card class="current-courier" v-if="shipping.courier && shipping.courier !== null">
          <h4 v-translate>Current Courier</h4>
          <user-card :user='shipping.courier' profile-picture-size="100px" :with-titles="false" :vertical="isNarrowWindow" />
        </b-card>

        <!-- <div v-if="shipping.threads && shipping.threads.filter(x => x.type === 'incidence').length > 0">
          <h4 v-translate>Incidence Messages</h4>
          <div v-for="(thread, i) in shipping.threads.filter(x => x.type === 'incidence')">
            <shipping-message-threads :the-thread="thread" :key="'thread' + thread.id" no-subject />
          </div>
        </div>
        <div class="text-center mb-4" v-else-if="(['INCIDENCE', 'WAITING'].indexOf(shipping.status) !== -1) && (!shipping.threads || shipping.threads.filter(x => x.type === 'incidence').length === 0)">
          <b-button size="sm" variant="dark" @click="messageThreadType = 'incidence'" v-b-modal.modalCreateThread v-translate>
            Start a New Incidence Message Thread
          </b-button>
        </div>

        <b-modal id="modalCreateThread" ref="modalCreateThread" size="lg" title="Submit your name" @hide="messageThreadType = ''" hide-footer>
          <template #modal-title><translate>New Message Thread</translate></template>
          <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
          <shipping-message-thread-form :type="messageThreadType" :shippingId="shipping.id" no-subject @success="$refs.modalCreateThread.hide(); getShipping();" @cancel="$refs.modalCreateThread.hide()" />
        </b-modal> -->

        <b-card :show="shipping.receiver_first_name" v-if="shipping.status === 'DELIVERED'">
          <h4 v-translate>Delivered to Info</h4>
          <b-row>
            <b-col cols="12" md="3" lg="5" class="text-center" v-if="(shipping.photos.length > 0 || shipping.receiver_signature) && (shipping.receiver_signature || (shipping.photos.find(x => x.type === 'SIGNATURE') && shipping.photos.find(x => x.type === 'SIGNATURE').full_path))">
              <a class="mr-2" href="#" v-b-modal.modalShowPicture @click.prevent="currentPicture = shipping.receiver_signature || (shipping.photos.find(x => x.type === 'SIGNATURE') && shipping.photos.find(x => x.type === 'SIGNATURE').full_path)"><img :src="shipping.receiver_signature || shipping.photos.find(x => x.type === 'SIGNATURE').full_path" alt="" style="height: auto; max-height: 100px; width: auto; max-width: 100%;"></a>
            </b-col>
            <b-col>
            <ul class="p-0">
              <li v-show="shipping.receiver_first_name"><translate>Receiver</translate>: {{shipping.receiver_first_name}} {{shipping.receiver_last_name}}</li>
              <li v-if="shipping.status_history[0] && shipping.status_history[0].details && shipping.status_history[0].details.receiver_uid" v-show="shipping.status_history[0].details.receiver_uid"><translate>Document</translate>: {{shipping.status_history[0].details.receiver_uid}}</li>
              <li v-show="shipping.receiver_address_street"><translate>Address</translate>: {{shipping.receiver_address_street}} {{shipping.receiver_address_number}}{{shipping.receiver_address_extra ? ', ' + shipping.receiver_address_extra : ''}}</li>
              <li v-show="shipping.receiver_phone"><translate>Phone</translate>: {{shipping.receiver_phone}}</li>
              <li v-show="shipping.receiver_comments"><translate>Comments</translate>: {{shipping.receiver_comments}}</li>
            </ul>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <h4 v-translate>Status History</h4>
          <shipping-status-history :shipping="shipping" @updated="getShipping" />
        </b-card>
      </b-col>
    </b-row>
    <b-alert v-else-if="unavailable" variant="warning" show>
      <h4 v-translate>This shipment is no longer available</h4>
      <p v-translate>It could not be loaded: it may no longer belong to your company. Its data and actions are hidden until it loads again.</p>
      <b-button size="sm" variant="primary" @click="getShipping" v-translate>Reload</b-button>
      <b-button size="sm" variant="link" :to="{ name: 'ShippingsList' }" v-translate>Back to shipments</b-button>
    </b-alert>

    <b-modal id="modalShowPicture" ref="modalShowPicture" size="lg" hide-footer @hidden="currentPicture = ''">
      <div slot="modal-title" v-translate>View Document</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div class="w-100">
        <img :src="currentPicture" alt="" class="w-100" v-if="!currentPicture.full_path">
        <embed :src="currentPicture.full_path +'?#scrollbar=0&toolbar=1&navpanes=0'" type="application/pdf" class="w-100" style="height: 85vh;" v-else>
      </div>
    </b-modal>

  </b-container>
</template>

<script>
import {
  ShippingService
} from '@/services/api'
import constants from '@/common/constants'
import ShippingsMixin from '@/mixins/shippings.mixin'
import ShippingAssignMixin from '@/mixins/shippingAssign.mixin'
import DataTransformersMixin from '@/common/dataTransformers'
import ShippingPickedupShippings from '@/components/Shippings/PickedupShippings'
import UserAutocomplete from '@/components/Autocompletes/UserAutocomplete'
import ShippingStatusUpdate from '@/components/Shippings/StatusUpdate'
// import ShippingCheckpoint from '@/components/Shippings/Checkpoint'
import ShippingCheckpointForm from '@/components/Shippings/CheckpointForm'
import ShippingStatusHistory from '@/components/Shippings/StatusHistory'
// import ShippingMessageThreads from '@/components/Shippings/MessageThreads'
import ShippingMessageThreadForm from '@/components/Shippings/MessageThreadForm'
import ShippingItems from '@/components/Shippings/Items'
import EditFieldItems from '@/components/Shippings/EditFieldItems'
import ModalShippingMap from '@/components/Maps/ModalShippingMap'
import ShippingAttachments from '@/components/Shippings/Attachments'
import ShippingsListItemStatus from '@/components/Shippings/ListItemStatus'

export default {
  name: 'ShippingEdit',
  title() {
    return this.$gettextInterpolate(this.$gettext('Shipment #%{shippingId}'), { shippingId: this.$options.filters.uuid(this.$route.params.id) })
  },
  components: {
    ShippingPickedupShippings,
    UserAutocomplete,
    ShippingStatusUpdate,
    ShippingCheckpoint: () => import('@/components/Shippings/Checkpoint'), // HACK :/
    ShippingCheckpointForm,
    ShippingStatusHistory,
    ShippingMessageThreads: () => import('@/components/Shippings/MessageThreads'), // HACK :/,
    ShippingMessageThreadForm,
    ShippingItems,
    EditFieldItems,
    ModalShippingMap,
    ShippingAttachments,
    ShippingsListItemStatus
  },
  props: {
    shippingId: {
      type: String,
      default: ''
    },
    oneColumn: {
      type: Boolean,
      default: false
    },
    allowResetCourier: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      shipping: {},
      // The last reload failed: no data nor action is shown on a shipping that may no longer be ours
      unavailable: false,
      originalShipping: {},
      patchField: {},
      editing: null,
      courier: null,
      itemEdit: {},
      messageThreadType: '',
      isNarrowWindow: false,
      currentPicture: ''
    }
  },
  computed: {
    isEditable() {
      return this.shipping.company &&
        this.shipping.status !== 'DELIVERED' &&
        this.shipping.status !== 'CANCELED' &&
        this.shipping.status !== 'RETURNED'
    },
    isShared() {
      return !this.shipping.company
    },
    isAssignable() {
      return this.isCarrierAssignable(this.shipping)
    },
    statusColorVariant() {
      let variant
      if (this.shipping.status === 'CANCELED') {
        variant = 'danger'
      } else if (this.shipping.status === 'INCIDENCE' || this.shipping.status === 'WAITINGCLIENT' || this.shipping.status === 'TOBERETURNED' || (this.shipping.status === 'DRAFT' && this.shipping.fields_revision)) {
        variant = 'warning'
      } else if (this.shipping.status === 'BLOCKED' || (this.shipping.status === 'DRAFT' && !this.shipping.fields_revision)) {
        variant = 'dark'
      } else {
        variant = 'success'
      }
      return variant
    },
    statusColorVariantFrom() {
      let variant
      if (this.shipping.status === 'INTRANSIT' || this.shipping.status === 'DELIVERED') {
        variant = 'success'
      } else {
        variant = 'dark'
      }
      return variant
    },
    statusColorVariantTo() {
      let variant
      if (this.shipping.status === 'DELIVERED') {
        variant = 'success'
      } else {
        variant = 'dark'
      }
      return variant
    }
  },
  watch: {
    shipping(newValue, oldValue) {
      if (this.shipping.tags) {
        this.tags = this.shipping.tags.map(x => {
          x.text = x.name
          return x
        })
      }
    },
    currentPicture(val) {
      if (val) {
        this.$refs.modalShowPicture.show()
      }
    }
  },
  mixins: [
    ShippingsMixin,
    ShippingAssignMixin,
    constants,
    DataTransformersMixin
  ],
  created() {
    this.shipping.id = this.shippingId || this.$route.params.id
  },
  mounted() {
    window.addEventListener('resize', this.watchWindowSize)
    this.watchWindowSize()
    this.getShipping()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.watchWindowSize)
  },
  methods: {
    watchWindowSize() {
      this.isNarrowWindow = window.innerWidth < 1280
    },
    // Also bound to events (@updated, @click): only an explicit { skipErrorAlert: true } is honoured
    getShipping(options) {
      this.$store.dispatch('showSpinner')
      const params = {
        includes: [
          'status_history',
          'user',
          'company',
          'courier.courier_available.tracking',
          'budget.quote',
          'tags',
          'threads.messages.sender',
          'previousShipping',
          'followingShippings',
          'items',
          'photos.applied_by',
          'shipping_order'
        ]
      }
      ShippingService.get(this.shipping.id, { params, skipErrorAlert: options?.skipErrorAlert === true })
        .then(response => {
          if (this.dataTransformers.shippings) {
            if (this.dataTransformers.shippings.transform) {
              response.body = this.dataTransformers.shippings.transform(response.body)
            }
          }
          this.shipping = response.body
          console.log(this.shipping)
          this.originalShipping = Object.assign({}, this.shipping)
          this.unavailable = false
          this.$store.dispatch('hideSpinner')
        }, () => {
          // POST /status does not check ownership (e.g. INCIDENCE before pickup drops the carrier):
          // drop the stale data so no form keeps acting on it
          this.shipping = { id: this.shipping.id }
          this.originalShipping = {}
          this.patchField = {}
          this.editing = null
          this.courier = null
          this.unavailable = true
          this.$store.dispatch('hideSpinner')
        })
    },
    updatePatch(obj, prop, event) {
      this.patchField[prop] = event
    },
    patchShipping() {
      if (
        confirm(this.$gettext('Are you sure you want to MODIFY current shipping field?'))
      ) {
        ShippingService.update(this.shipping.id, this.patchField)
          .then(() => {
            this.getShipping()
            this.originalShipping = {}
            this.patchField = {}
            this.editing = null
          })
      }
    },
    onSearchCourierSelected(item) {
      this.courier = item
      this.$refs.courierAc.searchQuery = ''
    },
    assignShipping(id) {
      this.assignShippingToCourier(id, this.courier.id)
        .then(() => {
          this.getShipping()
        }, error => {
          this.showAssignError(error)
          // Silent: once another carrier owns the shipping, the carrier GET answers 428 too
          this.getShipping({ skipErrorAlert: true })
        })
    }
  }
}
</script>

<style lang="scss">
.shipping-info, .shipping-checkpoint {
  border-top: 5px solid !important;
}
</style>
